// src/components/DATandBayes.jsx
import React from "react";

export default function DATandBayes() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-6 leading-relaxed text-sm"
      aria-labelledby="dat-bayes-heading"
    >
      <h2
        id="dat-bayes-heading"
        className="text-lg font-bold text-gray-100 mb-2"
      >
        DAT &amp; Bayes
      </h2>

      <div>
        <h3 className="font-semibold text-gray-200 mt-4 mb-1">
          What is Bayes’ Theorem?
        </h3>
        <p>
          In the eighteenth century, Thomas Bayes developed a mathematical
          theorem for updating the probability of a belief or hypothesis as new
          evidence emerges. Bayes’ Theorem provides a disciplined way to adjust
          what we think is likely or possible as more information becomes
          available.
        </p>
      </div>

      <div>
        <h3 className="font-semibold text-gray-200 mt-4 mb-1">
          How does <strong>Dialectical Analysis Theory </strong> use Bayes?
        </h3>
        <p>
          In DAT, Bayesian reasoning models uncertainty. Rather than forcing
          premature closure, DAT updates its confidence about whether a
          contradiction can be resolved as the analysis progresses. This keeps
          the process transparent, accountable and revisable, prioritising
          evidence-based epistemic clarity. Simply put, Bayes’ theorem updates
          the probability that a contradiction is resolvable as new evidence
          arrives.
        </p>
      </div>

      <div>
        <h3 className="font-semibold text-gray-200 mt-4 mb-1">
          Why Bayes in DAT?
        </h3>
        <p>
          Bayesian analysis in DAT is a discipline for holding uncertainty
          accountable. Instead of masking ambiguity or rushing to closure, DAT
          uses Bayes to make uncertainty visible and measurable, supporting
          intellectual honesty at every step.
        </p>
      </div>

      <ul className="list-disc list-inside space-y-2">
        <li>
          Models how likely a synthesis or resolution is, given the available
          information and the types of contradictions present.
        </li>
        <li>
          Updates its estimates as the analysis unfolds, offering transparency
          about when closure is likely—or when ambiguity persists.
        </li>
        <li>
          Ensures that epistemic claims in DAT are always <em>traceable</em>,{" "}
          <em>conditional</em>, and open to revision as knowledge changes.
        </li>
      </ul>

      <p>
        <strong>Note:</strong> Bayesian logic is used as a reasoning scaffold,
        not as a replacement for dialectical or phenomenological analysis.
      </p>
    </section>
  );
}
